import React from "react";

const Java_Compiler = () => {
  return (
    <div>
      <h1>Java Compiler</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Compiler in Java.</p>
    </div>
  );
};

export default Java_Compiler;
